"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Advice');

var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "chevron",
  size: "small"
});

function Advice(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      classNameProp = _ref.className,
      overridesProp = _ref.overrides,
      title = _ref.title,
      showIcon = _ref.showIcon,
      showCollapse = _ref.showCollapse,
      type = _ref.type,
      defaultCollapsed = _ref.defaultCollapsed,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "overrides", "title", "showIcon", "showCollapse", "type", "defaultCollapsed"]);
  var theme = (0, _styles.useTheme)();
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isEllipsisActive = _useState2[0],
      setEllipsisActive = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultCollapsed),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isCollapsed = _useState4[0],
      setIsCollapsed = _useState4[1];

  var textEl = (0, _react.useRef)(null);
  var textHeight = (0, _react.useRef)(null);
  (0, _react.useLayoutEffect)(function () {
    if (title) return;
    var el = textEl.current;
    setEllipsisActive(el.offsetWidth < el.scrollWidth);
    textHeight.current = el.offsetHeight; // Handling resize windows

    var handleResize = function handleResize() {
      return setEllipsisActive(el.offsetWidth < el.scrollWidth);
    };

    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [textEl, children, setEllipsisActive, title]); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Advice.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes[type], type), (0, _defineProperty2.default)(_classnames, classes.isCollapsed, isCollapsed), _classnames), classNameProp);
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName
  });
  var iconProps = (0, _react.useMemo)(function () {
    var properties = {
      size: 'medium'
    };

    switch (type) {
      case 'error':
        return (0, _extends2.default)({}, properties, {
          name: 'warning',
          color: theme.colors.red
        });

      case 'success':
        return (0, _extends2.default)({}, properties, {
          name: 'thickEnabled',
          color: theme.colors.green
        });

      case 'warning':
        return (0, _extends2.default)({}, properties, {
          name: 'warningRounded',
          color: theme.colors.yellow
        });

      case 'info':
      default:
        return (0, _extends2.default)({}, properties, {
          name: 'info',
          color: theme.colors.secondary
        });
    }
  }, [theme.colors.green, theme.colors.red, theme.colors.secondary, theme.colors.yellow, type]);
  var toggleCollapsing = (0, _react.useCallback)(function () {
    setIsCollapsed(!isCollapsed);
  }, [isCollapsed]);
  var showCollapsingIcon = isEllipsisActive || title;
  return /*#__PURE__*/_react.default.createElement("div", rootProps, showIcon && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.icon
  }, override.icon), /*#__PURE__*/_react.default.createElement(_Icon.default, iconProps)), !showCollapse && /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    className: classes.Text
  }, override.Text, {
    overrides: {
      root: {
        ref: textEl
      }
    }
  }), children), showCollapse && /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, (0, _extends2.default)({
    height: isCollapsed ? textHeight.current || 20 : 'auto'
  }, override['react-animate-height']), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.textContainer
  }, override.textContainer), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    isTruncated: isCollapsed,
    className: classes.Text
  }, override.Text, {
    overrides: {
      root: {
        ref: textEl
      }
    }
  }), !title && children, title && title), showCollapsingIcon && /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    onClick: toggleCollapsing,
    className: classes.dropdownIcon
  }, override.dropdownIcon), _ref2)), title && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.withTitleContainer
  }, /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    className: classes.Text
  }, override.Text, {
    overrides: {
      root: {
        ref: textEl
      }
    }
  }), children))));
}

Advice.overrides = ['root', 'icon', 'textContainer', 'Text', 'dropdownIcon', 'react-animate-height'];
Advice.defaultProps = {
  className: '',
  overrides: {},
  showIcon: false,
  showCollapse: true,
  type: 'info',
  defaultCollapsed: true
};
process.env.NODE_ENV !== "production" ? Advice.propTypes = {
  children: _propTypes.default.node.isRequired,
  title: _propTypes.default.any,
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  showIcon: _propTypes.default.bool,
  showCollapse: _propTypes.default.bool,
  defaultCollapsed: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['error', 'info', 'success', 'warning'])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Advice);

exports.default = _default;